export const DDC_VIDEO_RESUME = 'ddc.video.resume';
export const VIDEO_RESUME = 'video-resume';

// The FIRST play of a given <video> is reported as ddc.video.play (single-fire,
// which other tagging projects like Ford rely on). Every subsequent play — i.e.
// resuming after a pause — is reported as ddc.video.resume instead, so consumers
// that want per-play events (e.g. Stellantis) can opt in without changing the
// play-fires-once contract for everyone else.
//
// Tracked per element (not per source) so replays of the same file still count.
const playedOnce = new WeakSet();

function resume(event) {
	const {
		currentTarget: element,
		currentTarget: {
			duration: videoDuration = '',
			currentSrc: videoSource,
			seeking = false
		} = {}
	} = event;

	// First play (or no element) → let ddc.video.play own it; emit nothing here.
	if (!element || !playedOnce.has(element)) {
		if (element) {
			playedOnce.add(element);
		}
		return undefined;
	}

	// The browser auto-resumes playback once the user finishes scrubbing the
	// native seek bar (confirmed in a real browser: element.seeking is still
	// true when this 'play' handler runs). That resume is a seek artifact, not
	// a real resume — it's reported as ddc.video.seek instead (see seek.js).
	if (seeking) {
		return undefined;
	}

	return {
		eventType: DDC_VIDEO_RESUME,
		eventData: {
			element,
			videoSource,
			videoDuration,
			fileType:
				typeof videoSource === 'string'
					? videoSource.split('.').pop()
					: ''
		},
		overrides: {
			eventType: VIDEO_RESUME
		}
	};
}

export default resume;
